import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/DouyinProfileAudience.graphql';
import { Query, QuerydouyinProfileAudienceArgs } from '../../__generated__/globalTypes';

export const useDouyinProfileAudienceQuery = (options?: QueryHookOptions<Query, QuerydouyinProfileAudienceArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerydouyinProfileAudienceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useDouyinProfileAudienceLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerydouyinProfileAudienceArgs>
): QueryResult<Query, QuerydouyinProfileAudienceArgs> & {
  getDouyinProfileAudience: LazyQueryExecFunction<Query, QuerydouyinProfileAudienceArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getDouyinProfileAudience, result] = useLazyQuery<Query, QuerydouyinProfileAudienceArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getDouyinProfileAudience, ...result };
};

export const useDouyinProfileAudiencePromiseQuery = () => {
  const client = useApolloClient();

  const getDouyinProfileAudience = useCallback(
    (options?: Omit<QueryOptions<QuerydouyinProfileAudienceArgs, Query>, 'query'>) =>
      client.query<Query, QuerydouyinProfileAudienceArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getDouyinProfileAudience };
};
// Suspense Query Hooks
export const useDouyinProfileAudienceSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerydouyinProfileAudienceArgs>
) => {
  const result = useSuspenseQuery<Query, QuerydouyinProfileAudienceArgs>(QUERY, {
    ...options
  });

  return result;
};
